import { RouteLocationNormalized } from "vue-router";
import { BachelorsPortalDefinition, DistanceLearningPortalDefinition, MastersPortalDefinition, PhdPortalDefinition, ShortCoursesPortalDefinition } from "../models/definition";
import { FilterType } from "../models/filter";


const buildParams = (params: Record<string, string>): string => {
	const paramString = Object.entries(params)
		.filter(([key]) => key !== 'portal_type')
		.map(([, value]) =>  value)
		.join('/');

	return paramString ? `/${paramString}` : '';
}

const buildQuery = (query: Record<string, string>): string => {
	const queryString = Object.entries(query)
		.map(([key, value]) => {
			if((key as FilterType) === FilterType.DELIVERY_METHOD) {
				return `at=${value}`;
			}
			return  `${key}=${value}`;
		})
		.join('&');

	return queryString ? `?${queryString}` : '';
}


export const redirectUrlOmniSearch = (to: RouteLocationNormalized): string => {
	const shortCoursesPath = ShortCoursesPortalDefinition.path;
	const distanceLearningPath = DistanceLearningPortalDefinition.path;
	const bachelorsPath = BachelorsPortalDefinition.path;
	const phdPath = PhdPortalDefinition.path;
	const masterPath = MastersPortalDefinition.path;
	const prefix = '/search';
	const searchTypeRegex = new RegExp(`^/(${shortCoursesPath}|${distanceLearningPath}|${bachelorsPath}|${phdPath}|${masterPath})`, 'gm');
	const matchPath = to.fullPath.match(searchTypeRegex);

	if (window.isOmniSearchEnabled && matchPath)
	{
		const formattedQuery = buildQuery(to.query as Record<string, string>);
		const formattedParams = buildParams(to.params as Record<string, string>);


		const searchTypeMatch = to.fullPath.match(searchTypeRegex);
		const searchType = searchTypeMatch ? `/${searchTypeMatch[0]}` : '';

		return `${prefix}${searchType}${formattedParams}${formattedQuery}`;
	}

	return '';
}